import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project import
// import Logo from './LogoMain';
// import LogoIcon from './LogoIcon';
import InsightCampLogo from './InsightCampLogoMain';
import InsightCampLogoIcon from './InsightCampLogoIcon'
import { APP_DEFAULT_PATH } from 'config';
import useAuth from 'hooks/useAuth';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = ({ reverse, isIcon, sx, to }) => {
  const { isLoggedIn, user } = useAuth();
  const customUrl = user?.adminLogin ? '/streams' : APP_DEFAULT_PATH
  return (
    <ButtonBase disableRipple {...(isLoggedIn && { component: Link, to: !to ? customUrl : to, sx })}>
      {isIcon ? <InsightCampLogoIcon /> : <InsightCampLogo reverse={reverse} />}
    </ButtonBase>
  );
};

LogoSection.propTypes = {
  reverse: PropTypes.bool,
  isIcon: PropTypes.bool,
  sx: PropTypes.object,
  to: PropTypes.string
};

export default LogoSection;




{/* <ButtonBase disableRipple {...(isLoggedIn && { component: Link, to: !to ? APP_DEFAULT_PATH : to, sx })}>
{isIcon ? <LogoIcon /> : <Logo reverse={reverse} />}
</ButtonBase> */}
